import {BaseDto} from './base.dto';
import {TextUtils} from '../utils/TextUtils';
import {SubscriptionSource, SubscriptionSourceUtils} from '../models/subscriptionSource';
import SubscriptionFeatureDto from "./subscriptionFeature.dto";

export class SubscriptionDto extends BaseDto {
    private static readonly DAY_IN_MS = 1000 * 60 * 60 * 24;
    private static readonly AUTHOR_FIELD_CREATED_ON = 1619571601000;

    eshopOrderId: string;
    userCode: string;
    name: string;
    duration: number;
    subscribedOn: number;
    enabled: boolean;
    author: string;
    notes?: string;
    appStoreTransaction?: string;
    graceDuration?: number;
    graceStartedOn?: number;
    subscriptionPeriodUnit?: string;
    subscriptionFeatures: SubscriptionFeatureDto[] = [];

    authorEmail?: string; // This field is for convenience in order to store the author email instead of the author code.

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }

    public get isExpired(): boolean {
        return this.duration >= 0 && this.subscribedOn + SubscriptionDto.DAY_IN_MS * this.duration < new Date().getTime();
    }

    public get canExpire(): boolean {
        return this.duration >= 0;
    }

    public get hasAuthor(): boolean {
        return !TextUtils.isEmpty(this.author) && this.author !== this.userCode;
    }

    public get subscriptionSource(): string {
        if (TextUtils.isEmpty(this.appStoreTransaction) && TextUtils.isEmpty(this.author) && TextUtils.isEmpty(this.eshopOrderId) && this.subscribedOn < SubscriptionDto.AUTHOR_FIELD_CREATED_ON) {
            // This means that the subscription was created manually before 28 / 4 / 2021 where the `author` field was introduced.
            return SubscriptionSourceUtils.title(SubscriptionSource.CLOUD_ADMIN);
        } else if (!TextUtils.isEmpty(this.appStoreTransaction)) {
            return SubscriptionSourceUtils.title(SubscriptionSource.APPLE);
        } else if (!TextUtils.isEmpty(this.author) && TextUtils.isEmpty(this.appStoreTransaction)) {
            return SubscriptionSourceUtils.title(SubscriptionSource.CLOUD_ADMIN);
        } else {
            return SubscriptionSourceUtils.title(SubscriptionSource.ESHOP);
        }
    }

    public get expirationDate(): Date {
        const milliseconds = this.duration ? this.duration * SubscriptionDto.DAY_IN_MS : 0;
        return new Date(this.subscribedOn ? this.subscribedOn + milliseconds : milliseconds);
    }

}
